import { Button, GridView, Widget } from '@digital/ui';
import React, { useState, useMemo } from 'react';
import { Collapse } from 'antd';
import {
  CrfCicloOrcamentarioRelatorio,
  postGetAllRelatorioCicloOrcamentario,
  CrfFiltros,
  relatorioExportExcel,
} from '@app/api/crf/crfRelatorioCicloorcamentario';
import AbaPacote from '../RelatorioCicloOrcamentarioProjeto/AbaPacote';
import Grafico from '../RelatorioCicloOrcamentarioProjeto/Graficos';
import RelatorioCicloOrcamentarioTabela from '../RelatorioCicloOrcamentario/relatorioCicloOrcamentarioTabela';
import { postExportarRelatorio } from '@app/api/crf/crfRelatorioProjetoPacote';
import { hasPermission } from '@app/helpers/permissions';

const { Panel } = Collapse;
interface ResultCicloAnoProps {
  projetoId: string;
}

const ResultCicloAno = (props: ResultCicloAnoProps) => {
  const { projetoId } = props;
  const filtro = {} as CrfFiltros;
  const [cicloOrcamentarioRelatorioTotal, setCicloOrcamentarioRelatorioTotal] = useState<CrfCicloOrcamentarioRelatorio>();
  const idTodos = '00000000-0000-0000-0000-000000000000';

  useMemo(() => {
    if (projetoId) {
      if (projetoId != idTodos) {
      } else {
        postGetAllRelatorioCicloOrcamentario(filtro).then(data => {
          setCicloOrcamentarioRelatorioTotal(data);
        });
      }
    }
  }, [projetoId]);

  const hasExpostarRelatorio = () => {
    postExportarRelatorio();
  };

  const btnExportar = () => {
    const btnExportarResult = [];

    if (hasPermission(['PROJETOS_TODOS_PROJETOS_CICLO_ORCAMENTARIO_BOTAO_EXPORTA_RELATORIO_VISUALIZAR'])) {
      btnExportarResult.push(
        <Button
          type="link"
          size={'small'}
          icon="files-ms_excel"
          onClick={() => {
            relatorioExportExcel(filtro);
          }}>
          Exporta Relatório
        </Button>,
      );
    }
    if (
      hasPermission(['PROJETOS_TODOS_PROJETOS_CICLO_ORCAMENTARIO_BOTAO_EXPORTA_RELATORIO_PROJETO_PACOTE_VISUALIZAR'])
    ) {
      btnExportarResult.push(
        <Button
          type="primary"
          size={'small'}
          icon="files-ms_excel"
          onClick={() => {
            hasExpostarRelatorio();
          }}>
          Exporta Relatório Projeto Pacote
        </Button>,
      );
    }

    return btnExportarResult;
  };

  return projetoId === idTodos ? (
    <>
      <GridView noform>
        <Widget title="RESULTADO" span={12} actions={btnExportar()}>
          {cicloOrcamentarioRelatorioTotal ? (
            <>
              <RelatorioCicloOrcamentarioTabela
                cicloOrcamentarioRelatorioTotal={
                  cicloOrcamentarioRelatorioTotal ? cicloOrcamentarioRelatorioTotal : ({} as CrfCicloOrcamentarioRelatorio)
                }
                filtro={filtro}
                mostrarColunaDetalhe={false}
                quantidadeItemPaginacao={10}
              />
            </>
          ) : (
            <></>
          )}
        </Widget>
      </GridView>
    </>
  ) : (
    <>
      <>
        <AbaPacote projetoId={projetoId} pageSize={10} />
        <Grafico projetoId={projetoId} />
      </>
    </>
  );
};

export default ResultCicloAno;
